import type { PropsWithChildren } from 'react';

const GiveNowItemsWrapper = ({ children }: PropsWithChildren) => <div className="give-options-wrapper">{children}</div>;

export default GiveNowItemsWrapper;
